// extracted by mini-css-extract-plugin
module.exports = {"button":"Matches_button__1-PKX","active":"Matches_active__3Zdz4","top":"Matches_top__2-P7T"};